<template>
  <v-container>
    <v-row v-if="examQuestion.question">
      <v-col cols="12" md="12">
        <div>{{ examQuestion.questionHint }}</div>
        <p dir="auto" style="white-space: pre-line !important;"  class="title text--primary pt-2 pb-4 text-justify">
          {{ examQuestion.question.trim() }}
        </p>
        <div v-if="examQuestion.containsFile">
          <div
            v-if="
              get_url_extension(examQuestion.fileUrl) == 'jpg' ||
                get_url_extension(examQuestion.fileUrl) == 'jpeg' ||
                get_url_extension(examQuestion.fileUrl) == 'png' ||
                get_url_extension(examQuestion.fileUrl) == 'gif' ||
                get_url_extension(examQuestion.fileUrl) == 'bmp'
            "
          >
            <v-img
              lazy-src="../../assets/loadImg.svg"
              :src="examQuestion.fileUrl"
              width="100%"
              max-width="600"
            ></v-img>
          </div>
          <div v-else>
            <download-file v-if="examQuestion.containsFile" :fileUrl="examQuestion.fileUrl">
            </download-file>
          </div>
        </div>
        <p class="pt-4">
          {{
            `${
              examQuestion.questionType == "MultiChoice"
                ? $t("exam.MultipleChoices")
                : examQuestion.questionType == "OneChoice"
                ? $t("exam.ChooseOne")
                : examQuestion.questionType == "FillInTheBlanks"
                ? $t("exam.FillInTheBlank")
                : examQuestion.questionType == "Number"
                ? $t("exam.FillInTheBlankNumericValue")
                : examQuestion.questionType == "AttachedFile"
                ? $t("exam.UploadAFile")
                : ""
            } - ( ${$t("exam.TheDegreeOfTheQuestion")} :  ${examQuestion.questionMark} ) `
          }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DownloadFile from "../downloadFile.vue";

export default {
  components: {
    DownloadFile
  },
  props: ["examQuestion"],
  data() {
    return {};
  },
  methods: {
    get_url_extension(url) {
      return url
        .split(/[#?]/)[0]
        .split(".")
        .pop()
        .trim()
        .toLowerCase();
    }
  }
};
</script>

<style></style>
